import { combineReducers } from 'redux';
import exerciseEntities from './exerciseEntities';
import licenseAgreements from './licenseAgreements';
import localExercises from './localExercises';
export default combineReducers({
  exerciseEntities,
  licenseAgreements,
  localExercises
});